import React from "react";
import { Alert, Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface FiltersPanelProps {
  periodoDesde: string;
  periodoHasta: string;
  onPeriodoDesdeChange: (valor: string) => void;
  onPeriodoHastaChange: (valor: string) => void;
  opcionesServidores: SelectOption[];
  servidorSeleccionado: string;
  onServidorChange: (valor: string) => void;
  opcionesSucursales: SelectOption[];
  sucursalSeleccionada: string;
  onSucursalChange: (valor: string) => void;
  opcionesTurnos: SelectOption[];
  turnoSeleccionado: string;
  onTurnoChange: (valor: string) => void;
  opcionesCajas: SelectOption[];
  cajaSeleccionada: string;
  onCajaChange: (valor: string) => void;
  opcionesCajeros: SelectOption[];
  cajeroSeleccionado: string;
  onCajeroChange: (valor: string) => void;
  estadoSeleccionado: string;
  estadoOpciones: SelectOption[];
  onEstadoChange: (valor: string) => void;
  opcionesFormasPago: SelectOption[];
  formaPagoSeleccionada: string;
  onFormaPagoChange: (valor: string) => void;
  cargando: boolean;
  error?: string | null;
  onReload: () => void;
}

const FiltersPanel = ({
  periodoDesde,
  periodoHasta,
  onPeriodoDesdeChange,
  onPeriodoHastaChange,
  opcionesServidores,
  servidorSeleccionado,
  onServidorChange,
  opcionesSucursales,
  sucursalSeleccionada,
  onSucursalChange,
  opcionesTurnos,
  turnoSeleccionado,
  onTurnoChange,
  opcionesCajas,
  cajaSeleccionada,
  onCajaChange,
  opcionesCajeros,
  cajeroSeleccionado,
  onCajeroChange,
  estadoSeleccionado,
  estadoOpciones,
  onEstadoChange,
  opcionesFormasPago,
  formaPagoSeleccionada,
  onFormaPagoChange,
  cargando,
  error,
  onReload,
}: FiltersPanelProps) => {
  const disabled = cargando;
  const dependientesDeshabilitados = disabled || !periodoDesde || !periodoHasta;
  const botonActualizarDeshabilitado = disabled || !periodoDesde || !periodoHasta;

  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap justify-content-end mb-3 gap-2">
        <Button color="light" onClick={onReload} disabled={botonActualizarDeshabilitado}>
          {cargando ? "Actualizando..." : "Actualizar"}
        </Button>
      </div>

      {error && (
        <Alert color="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Form>
        <Row className="g-3">
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-desde">Desde</Label>
              <Input
                id="filtro-desde"
                type="date"
                value={periodoDesde}
                onChange={(event) => onPeriodoDesdeChange(event.target.value)}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-hasta">Hasta</Label>
              <Input
                id="filtro-hasta"
                type="date"
                value={periodoHasta}
                onChange={(event) => onPeriodoHastaChange(event.target.value)}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-servidor">Servidor</Label>
              <Input
                id="filtro-servidor"
                type="select"
                value={servidorSeleccionado}
                onChange={(event) => onServidorChange(event.target.value)}
                disabled={disabled}
              >
                {opcionesServidores.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-sucursal">Sucursal</Label>
              <Input
                id="filtro-sucursal"
                type="select"
                value={sucursalSeleccionada}
                onChange={(event) => onSucursalChange(event.target.value)}
                disabled={disabled}
              >
                {opcionesSucursales.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-turno">Turno</Label>
              <Input
                id="filtro-turno"
                type="select"
                value={turnoSeleccionado}
                onChange={(event) => onTurnoChange(event.target.value)}
                disabled={dependientesDeshabilitados}
              >
                {opcionesTurnos.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-caja">Caja</Label>
              <Input
                id="filtro-caja"
                type="select"
                value={cajaSeleccionada}
                onChange={(event) => onCajaChange(event.target.value)}
                disabled={dependientesDeshabilitados}
              >
                {opcionesCajas.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-cajero">Cajero</Label>
              <Input
                id="filtro-cajero"
                type="select"
                value={cajeroSeleccionado}
                onChange={(event) => onCajeroChange(event.target.value)}
                disabled={dependientesDeshabilitados}
              >
                {opcionesCajeros.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-estado">Estado de conciliación</Label>
              <Input
                id="filtro-estado"
                type="select"
                value={estadoSeleccionado}
                onChange={(event) => onEstadoChange(event.target.value)}
                disabled={dependientesDeshabilitados}
              >
                {estadoOpciones.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="filtro-forma-pago">Forma de pago</Label>
              <Input
                id="filtro-forma-pago"
                type="select"
                value={formaPagoSeleccionada}
                onChange={(event) => onFormaPagoChange(event.target.value)}
                disabled={dependientesDeshabilitados}
              >
                {opcionesFormasPago.map((opcion) => (
                  <option key={opcion.value} value={opcion.value} disabled={opcion.disabled}>
                    {opcion.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FiltersPanel;
